function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import Ribbon from '@shared/components/ribbon';
import { DataMap } from '@shared/utils/dataMapping';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
import { logger } from '@src/logger';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { getProductByUrlKey } from '@shared/utils/appUtils';
import { urlKeys } from '@shared/utils/datamappingHelpers';
export class CuratedGallery extends SpzaComponent {
    componentDidMount() {
        const sectionsTelemetry = (this.props.sections || []).map((section)=>{
            return {
                titleId: section.titleId,
                sectionItemsLength: section.items ? section.items.length : 0
            };
        });
        const detailsObject = {
            message: 'main page swim lanes: ',
            sections: sectionsTelemetry
        };
        const perfPayload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End,
            details: JSON.stringify(detailsObject)
        };
        logger.info(perfPayload.details, {
            action: perfPayload.action,
            actionModifier: perfPayload.actionModifier
        });
    }
    getDetailsPageUrl(titleId) {
        let url = '';
        let isUrlKeyExists = false;
        let filterName = '';
        const urlFilters = {
            category: null,
            industry: null,
            product: null,
            search: null,
            sortBy: null
        };
        Object.keys(urlKeys).forEach((urlKey)=>{
            if (urlKeys[`${urlKey}`][`${titleId}`]) {
                isUrlKeyExists = true;
                filterName = urlKey;
            }
        });
        if (isUrlKeyExists) {
            if (filterName === Constants.DataMapCollectionKeys.products) {
                const productInfo = getProductByUrlKey({
                    urlKey: titleId
                });
                const shortcutFilters = productInfo === null || productInfo === void 0 ? void 0 : productInfo.ShortcutFilters;
                if (shortcutFilters) {
                    urlFilters.product = shortcutFilters.join(';');
                } else {
                    urlFilters.product = titleId;
                }
            } else {
                if (filterName === Constants.DataMapCollectionKeys.categories) {
                    urlFilters.category = titleId;
                } else if (filterName === Constants.DataMapCollectionKeys.industries) {
                    urlFilters.industry = titleId;
                }
            }
            url = this.context.buildHref(getEntityRegistration(this.props.entityType).route, null, urlFilters);
        }
        return url;
    }
    getTitle(section) {
        var _DataMap__;
        let titleId = section.titleId;
        if (titleId === Constants.FeaturedAppsId) {
            return this.context.loc('CuratedType_FeaturedApps');
        }
        let isUrlKeyExists = false;
        let filterName = '';
        Object.keys(urlKeys).forEach((urlKey)=>{
            if (urlKeys[`${urlKey}`][`${titleId}`]) {
                isUrlKeyExists = true;
                filterName = urlKey;
            }
        });
        if (isUrlKeyExists && filterName !== Constants.DataMapCollectionKeys.categories && ((_DataMap__ = DataMap[`${filterName}`][`${titleId}`]) === null || _DataMap__ === void 0 ? void 0 : _DataMap__.LocKey)) {
            titleId = this.context.loc(DataMap[`${filterName}`][`${titleId}`].LocKey, DataMap[`${filterName}`][`${titleId}`].Title);
        } else if (isUrlKeyExists && filterName === Constants.DataMapCollectionKeys.categories) {
            const isCategoryExist = Object.keys(DataMap.categories).filter((catagorySection)=>{
                var _DataMap_categories__;
                return (_DataMap_categories__ = DataMap.categories[`${catagorySection}`][`${titleId}`]) === null || _DataMap_categories__ === void 0 ? void 0 : _DataMap_categories__.LocKey;
            });
            if (isCategoryExist && isCategoryExist.length) {
                titleId = this.context.loc(DataMap.categories[`${isCategoryExist[0]}`][`${titleId}`].LocKey, DataMap.categories[`${isCategoryExist[0]}`][`${titleId}`].Title);
            }
        }
        if (section.titleLocId) {
            titleId = this.context.loc(section.titleLocId, titleId);
        }
        return titleId;
    }
    renderImpl() {
        const TileType = getEntityRegistration(this.props.entityType).tileType;
        const { sections, selectedCountry, selectedLocale } = this.props;
        sections === null || sections === void 0 ? void 0 : sections.map((section)=>{
            var _section_items;
            return section.items = (section === null || section === void 0 ? void 0 : (_section_items = section.items) === null || _section_items === void 0 ? void 0 : _section_items.filter((item)=>!isOneTimePaymentOffer(item.entityId))) || [];
        });
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "spza_controls"
                }),
                sections ? sections.map((section, key)=>{
                    const ribbonItems = section.items.length > this.maxTileDisplay ? section.items.slice(0, this.maxTileDisplay) : section.items;
                    return /*#__PURE__*/ _jsx(Ribbon, {
                        title: this.props.getSectionTitle ? this.props.getSectionTitle(section.titleId) : this.getTitle(section),
                        seeMoreUrl: this.props.getSeeMoreLink ? this.props.getSeeMoreLink(section.titleId, this.context) : this.getDetailsPageUrl(section.titleId),
                        seeMoreText: this.props.isMobile ? this.context.loc('PartnerDetail_More') : this.context.loc('Link_SeeAll'),
                        children: ribbonItems.map((item, index)=>{
                            return /*#__PURE__*/ _createElement(TileType, _object_spread_props(_object_spread({}, item), {
                                item: item,
                                key: item.entityId || item.solutionId,
                                customCSSClass: 'tile' + index,
                                tileIndex: index,
                                totalTiles: ribbonItems.length,
                                selectedLocale: selectedLocale,
                                embedHost: this.props.embedHost,
                                countryContext: selectedCountry,
                                ribbonKey: section.titleId
                            }));
                        })
                    }, key);
                }) : null
            ]
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "maxTileDisplay", this.props.embedHost ? 4 : 5);
    }
}
CuratedGallery.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
